__turbopack_context__.v({
  "skipToMainContent": "skip-to-main-content-module-scss-module__8u9vba__skipToMainContent",
});
